<p>By using this website you agree to the privacy policy <span class="click" (click)="openPrivacyDialog()">Privacy policy</span> <span class="click" (click)="close()">Close</span></p>
